module.exports = __webpack_public_path__ + "img/home_icon03.d15a55dd.png";